
import MarketAnalysisPortfolioInfo from "@/components/marketAnalysis/MarketAnalysisPortfolioInfo";
import PersonalizedMarketReportCard from "@/components/marketAnalysis/PersonalizedMarketReportCard";
import ReportSubscriptionBanner from "@/components/marketAnalysis/ReportSubscriptionBanner";
import ReportSubscriptionModal from "@/components/marketAnalysis/ReportSubscriptionModal";
import AuthService from '@/service/AuthService';

export default {
    name: 'PersonalizedSection',

    components: {
        PersonalizedMarketReportCard,
        ReportSubscriptionBanner,
        MarketAnalysisPortfolioInfo,
        ReportSubscriptionModal,
    },

    data() {
        return {
            isReportSubscriptionModalOpened: false,
            personalizedReportSubscriptionActive: null,
            personalizedReportSubscriptionFrequency: null,
        };
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user
        },
        subscriptionFrequency() {
            return this.personalizedReportSubscriptionActive ? this.personalizedReportSubscriptionFrequency : null;
        }
    },

    watch: {
        isLoggedIn: {
            handler(value) {
                if (!value) {
                    return;
                }
                this.fetchPersonalizedReportSubscriptionActive();
                this.fetchPersonalizedReportSubscriptionFrequency();
            },
            immediate: true
        },
    },

    methods: {
        async fetchPersonalizedReportSubscriptionActive() {
            try {
                this.personalizedReportSubscriptionActive = await AuthService.getPersonalizedlReportSubscriptionActive(this.$axios);
            } catch (error) {
                this.personalizedReportSubscriptionActive = null;
            }
        },
        async fetchPersonalizedReportSubscriptionFrequency() {
            try {
                this.personalizedReportSubscriptionFrequency = await AuthService.getPersonalizedReportSubscriptionFrequency(this.$axios);
            } catch (error) {
                this.personalizedReportSubscriptionFrequency = null;
            }
        },
        openReportSubscriptionModal() {
            this.isReportSubscriptionModalOpened = true;
        },
        updateReportActive(value) {
            this.personalizedReportSubscriptionActive = value;
        },
        updateReportFrequency(value) {
            this.personalizedReportSubscriptionFrequency = value;
        }
    }
}
